import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useMutation } from "@tanstack/react-query";
import { App } from "antd";

export const useUserResetPassword = () => {
    const axios = useAxios();
    const { t } = useTranslation();
    const {notification} = App.useApp();

    const resetPassword = async (id: string) => {
        try {
            return await axios.post(`/api/user/forgotpassword`, {id});
        } catch (error) {
            throw new Error(t("messages.error.resetPassword"));
        }
    }

    return useMutation({mutationFn: resetPassword,
        onSuccess: () => {
            notification.success({
                message: t("messages.success.resetPassword"),
                description: t("messages.success.resetPasswordDesc"),
            });
        }
    });
}